// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__l5wep","slick-next":"CustomSlider_slick-next__QlCIH"};